import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectIsMobileLayout } from '../../selectors/layout';
import { AppContext } from '../../../AppModulesWrapper';
import { SaveDraftButtonContainer } from '../SaveDraftButton';
import * as styles from './NeedIdentification.css';

export const NeedIdentification = () => {
  const isMobile = useSelector(selectIsMobileLayout);
  const { isMicrofrontend } = React.useContext(AppContext);

  return isMicrofrontend ? null : (
    <div className={isMobile ? styles['mobile_wrapper'] : styles['desktop_wrapper']}>
      <SaveDraftButtonContainer />
    </div>
  );
};
